import { Dispatch } from '@reduxjs/toolkit';
import { setAccommodations } from '../actions';
import { AppState } from '../store';

export function getAccommodations(): ReduxAction {
  return async (dispatch: Dispatch, getState: () => AppState) => {
    const {
      general: { appConfiguration, accessToken },
    } = getState();

    try {
      const data = await fetch(`${appConfiguration.VITE_API_SALES_CONFIGURATION}/api/Accommodation`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const accommodations = await data.json();
      dispatch(setAccommodations(accommodations));
    } catch (error) {
      console.error(error);
    }
  };
}
